import { useTermsUrl } from "app/context/BrandingContext";

interface TermsLinkProps {
  className?: string;
  children?: React.ReactNode;
}

/** "Terms of Service" — links to the partner's T&C (tncUrl) when the assets API provides one. */
export default function TermsLink({ className, children = "Terms of Service" }: TermsLinkProps) {
  const termsUrl = useTermsUrl();

  if (termsUrl) {
    return (
      <a href={termsUrl} target="_blank" rel="noopener noreferrer" className={className}>
        {children}
      </a>
    );
  }

  return (
    <button type="button" className={className}>
      {children}
    </button>
  );
}
